document.addEventListener('DOMContentLoaded', function () {
  var season = document.documentElement.getAttribute('data-season');
  if (!season) return;

  var contentBySeason = {
    winter: {
      announcement: 'Winter Drop Is Here - cool tones, cozy edits, and limited shipping perks at checkout',
      heroHeading: 'Winter Studio Edit',
      heroText: 'Ice-toned highlights, curated drops, and statement pieces styled for the cold season.',
      cta: 'Shop Winter Drop'
    },
    spring: {
      announcement: 'Spring Refresh Is Live - discover fresh arrivals and bright picks with checkout perks',
      heroHeading: 'Spring Refresh',
      heroText: 'Fresh colors, lighter textures, and curated pieces designed to brighten the season.',
      cta: 'Shop Spring Picks'
    },
    summer: {
      announcement: 'Summer Edit Is Live - bold colors, preorder drops, and checkout shipping deals await',
      heroHeading: 'Handcrafted Garments',
      heroText: 'Sun-washed tones, preorder highlights, and standout pieces curated for warm-season shopping.',
      cta: 'Shop Here'
    },
    fall: {
      announcement: 'Fall Essentials Are Live - warm layers, rich tones, and seasonal checkout offers',
      heroHeading: 'Fall Essentials',
      heroText: 'Earthy tones, richer textures, and curated drops built for the season shift.',
      cta: 'Shop Fall Picks'
    }
  };

  var content = contentBySeason[season];
  if (!content) return;

  var announcement = document.querySelector('.announcement-bar__message');
  if (announcement) {
    announcement.childNodes[0].nodeValue = content.announcement;
  }

  var heroHeading = document.querySelector('.banner__heading span');
  if (heroHeading) {
    heroHeading.textContent = content.heroHeading;
  }

  var heroText = document.querySelector('.banner__text span');
  if (heroText) {
    heroText.textContent = content.heroText;
  }

  var heroCta = document.querySelector('.banner__buttons .button');
  if (heroCta) {
    heroCta.textContent = content.cta;
  }
});
